import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import * as moment from 'moment';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import { ActivatedRoute } from '@angular/router';
import { AddBankDialog } from './addbank/addbank.component';

@Component({
    selector: 'app-bank',
    templateUrl: './bank.component.html',
    styleUrls: ['./bank.component.css']
})
export class BankComponent implements OnInit {

    displayedColumnsBnaks = [
        'firstName',
        'lastName',
        'middleName',
        'mobileNumber',
        'panNo',
        'ifscCode',
        'remitterAccountNumber',
        'vanAccNumber',
        'vanIfscCode',
        'updatedAt'
    ];
    public dataSourceBnaks: any = new MatTableDataSource();
    @ViewChild('paginatorBnaks', { read: MatPaginator }) paginatorBnaks: MatPaginator;
    @ViewChild('sortBnaks', { read: MatSort }) sortBnaks: MatSort;
    filter: any;
    pageSizeBnaks = 10;
    userId: any;
    currentPageBnaks = 0;
    pageSizeOptionsBnaks: number[] = [5, 10, 25, 50, 100];
    constructor(private userService: UserService,
        private route: ActivatedRoute,
        private dialog: MatDialog,
    ) {
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSourceBnaks.filter = filterValue;
    }
    async pageChangedBnaks(event: PageEvent) {
        this.pageSizeBnaks = await event.pageSize;
        this.currentPageBnaks = await event.pageIndex;
    }
    ngOnInit() {
        this.userId = this.route.snapshot.paramMap.get('id');
        this.getUserBankDetails();
    }

    async createBankByUser() {
        this.dialog.open(AddBankDialog, {
            data: {userid: this.userId}
        }).afterClosed().subscribe(() => {
            this.getUserBankDetails();
        });
    }
    async exportArray() {
        if (this.dataSourceBnaks.filteredData) {
            const bank = await this.dataSourceBnaks.filteredData.map(bank => ({
                "Updated At" : bank.updatedAt,
                "First Name" : bank.firstName,
                "Last Name" : bank.lastName,
                "Middle Name" : bank.middleName,
                "Mobile Number" : bank.mobileNumber,
                "Pan No" : bank.panDetails,
                "IFSC Code" : bank.customerAccountDetails[0].ifscCode,
                "Remitter Account Number" : bank.customerAccountDetails[0].accountNumber,
                "Virtual Account Number" : bank.vanAccNumber,
                "Virtual IFSC Code" : bank.vanIfscCode,
            }));
            TableUtil.exportArrayToExcel(bank, "bank");
        }

    }
    getUserBankDetails() {
        if (this.userId) {
            this.userService.getUserBank(this.userId).subscribe(Bnaks => {               
                let BnaksRes = Bnaks.map(bank => {
                    bank.panNo = bank.panDetails;
                    bank.ifscCode = bank.customerAccountDetails[0].ifscCode;
                    bank.remitterAccountNumber = bank.customerAccountDetails[0].accountNumber;
                    bank.updatedAt = moment(bank.updatedAt).format('MM/DD/YY h:mm:ss A');
                    return bank;
                })
                if (BnaksRes) {
                    this.dataSourceBnaks = new MatTableDataSource(BnaksRes);
                    this.dataSourceBnaks.paginator = this.paginatorBnaks;
                    this.dataSourceBnaks.sort = this.sortBnaks;
                } else {
                    this.dataSourceBnaks = new MatTableDataSource([])
                };
            })
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/bank/bank.component.ts